import { render, staticRenderFns } from "./transactions-report-filter.vue?vue&type=template&id=2b7f6ff5&"
import script from "./transactions-report-filter.vue?vue&type=script&lang=js&"
export * from "./transactions-report-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports